export enum FoundationAssemblyType {
  SOLID = "SOLID",
  VOID = "VOID",
}
